'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
exports.Server = void 0;
var Server;
(function (Server) {
    Server['Sandbox'] =
        'https://p9p3lf0b0l.execute-api.eu-central-1.amazonaws.com/dev/attachments';
    Server['Dev'] =
        'https://crm-sf-attachments.dev.connected-biking.cloud/attachments';
    Server['Stage'] =
        'https://crm-sf-attachments.stage.connected-biking.cloud/attachments';
    Server['Qa'] =
        'https://crm-sf-attachments.qa.connected-biking.cloud/attachments';
    Server['Prod'] =
        'https://crm-sf-attachments.prod.connected-biking.cloud/attachments';
})(Server || (exports.Server = Server = {}));
